import React from 'react'

import Button from './Button'
import Dropdown from './Dropdown'
import { useI18N } from '../../../libraries/i18n/hook'
import { useToaster } from '../../../libraries/toaster'
import ShareIcon from '../../../assets/icons/share.svg?react'
import useDeviceDetection from '../../../hocs/useDeviceDetection'

type Props = { title?: string, size?: 'sm' | 'md', link?: string, text?: string, hideIcon?: boolean, textColor?: string }
const ShareButton: React.FC<Props> = ({ title, size = 'sm', link, text, hideIcon, textColor = 'deep-green' }) => {
  const device = useDeviceDetection()
  const { showSuccess } = useToaster()
  const { t } = useI18N()

  const isMobileOrTablet = device.isMobile || device.isTablet
  const copyLinkToClipBoard = async (url: string) => {
    try {
      await navigator.clipboard.writeText(url)
      showSuccess(t('common.clipboardCopied'))
    } catch (err) {
      console.error('Failed to copy URL: ', err)
    }
  }

  const handleShare = async () => {
    const url = link ?? window.location.href
    if (isMobileOrTablet && navigator.share) {
      try {
        await navigator.share({ title: title ?? document.title, url: url })
      } catch (error) {
        if ((error as Error).name !== 'AbortError') {
          console.error('Error trying to share link:', error)
          // Fallback copy to clipboard
          await copyLinkToClipBoard(url)
        }
      }
    } else {
      // For desktop - copy to clipboard
      await copyLinkToClipBoard(url)
    }
  }

  const renderButton = (onClick = () => {}) => {
    return (
      <Button onClick={onClick} className={`${hideIcon && 'contents'} text-${textColor} sm:font-normal`} variant='flat' size={size} icon={!hideIcon ? <ShareIcon stroke='deep-green' /> : undefined}>
        {text ?? t('common.share')}
      </Button>
    )
  }

  if(isMobileOrTablet) {
    return renderButton(handleShare)
  }

  return (
    <Dropdown originRight mt={2} items={[
      { id: 'copyLink', item: <button onClick={handleShare} className='min-w-[150px] text-black w-full block'>{t('common.copyLink')}</button> },
    ]}>
      {renderButton()}
    </Dropdown>
  )
}

export default ShareButton
